export default "__VITE_PUBLIC_ASSET__af0aaa16__"